import * as React from "react";
import Icon from "~/components/icons/icon";
import classNames from "classnames";
import { WrappedFieldProps } from "redux-form";

export interface IInputCheckboxProps {
    label: string;
    fieldName: string;
    required?: boolean;
    requiredIndicatorOnly?: boolean;
    className?: string;
    idPrefix?: string;
    switchStyle: boolean;
}

const InputCheckbox: React.FC<IInputCheckboxProps & WrappedFieldProps> = props => {
    const label = props.required || props.requiredIndicatorOnly ? `${props.label} *` : props.label;
    const baseClass = "checkbox";
    const rootClasses = classNames(baseClass, props.className, {
        [`${baseClass}--switchStyle`]: props.switchStyle
    });
    const inputId = props.idPrefix ? props.idPrefix + "_" + props.fieldName : props.fieldName;

    return (
        <label className={rootClasses} htmlFor={inputId}>
            <input
                {...props.input}
                className={`${baseClass}__input`}
                type="checkbox"
                id={inputId}
                required={props.required}
                checked={props.input.value}
                autoComplete="off"
            />
            <div className={`${baseClass}__mark-container`} role="presentation">
                <span className={`${baseClass}__mark`}>
                    <Icon iconId="icon_placeholder_checkmark" />
                </span>
            </div>
            <div
                className={`${baseClass}__label content-rich-text`}
                dangerouslySetInnerHTML={{ __html: label }}
            />
        </label>
    );
};

export default InputCheckbox;
